import { useEffect, useRef, useState } from "react";
import Popover from "../popover/popover";
import SpeedIcon from "./speedIcon";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import useOnClickOutside from "helpers/hooks/useOnClickOutside";
import { setSpeedPopover } from "redux-share/slices/popoversSlice";
import { conditions, handlePopoverSizeInMiniPlayer, videoTag } from "helpers";
import { ConditionName } from "interfaces";
import { setUserSettings } from "redux-share/slices/userSlice";
import { createSettings } from "redux-share/actions/user.actions";
import { sendFluentLog, speedChangeLog } from "../../../../../logs";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const ControllbarTooltip = dynamic(() => import("../../mainComponent/footer/controllbar/controllbarTooltip"));
const CloseIcon = dynamic(() => import("../../icon-components/closeIcon"));

const speeds = [0.5, 0.8, 1, 1.25, 1.5, 1.75, 2]

const Speed = () => {

    const [showTooltip, setShowTooltip] = useState<boolean>(false);

    const dispatch = useAppDispatch();
    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { videoElementSizeInfo, params } }) => ({ videoElementSizeInfo, params }), shallowEqual);
    const { speedPopover } = useAppSelector(({ popovers: { speedPopover } }) => ({ speedPopover }), shallowEqual);
    const { settings } = useAppSelector(({ user: { settings } }) => ({ settings }), shallowEqual);

    const speedRef = useRef<any>(null);

    useOnClickOutside(speedRef, () => {
        if (speedPopover) dispatch(setSpeedPopover(false));
    });

    useEffect(() => {
        if (videoTag()) videoTag().playbackRate = settings.speed;
    },[])

    return (
        <div className={`pl-inline-flex pl-relative`} ref={speedRef}>
            <SpeedIcon
                onClick={() => dispatch(setSpeedPopover(!speedPopover))}
                onMouseOver={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(true)}
                onMouseLeave={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(false)}
            />
            {showTooltip && <ControllbarTooltip title="سرعت پخش (s)" className="!pl-right-[-38px]" />}
            <Popover
                classNames={`!pl-p-0 pl-overflow-hidden ${!conditions(ConditionName.isComplexPortrait) && "pl-mb-[33px] pl-right-0"} ${conditions(ConditionName.isMiniPlayer) && !conditions(ConditionName.isFullMobilePortrait) ? `!pl-fixed pl-rounded-r-none pl-w-[200px] !pl-mb-0` : "pl-w-[285px]"}`}
                animation={conditions(ConditionName.isMiniPlayer) && !conditions(ConditionName.isFullMobilePortrait) ? (speedPopover ? "animate__fadeInRight" : "animate__fadeOutRight") : undefined}
                styles={handlePopoverSizeInMiniPlayer()}
                status={speedPopover}
                onClose={() => dispatch(setSpeedPopover(false))}
                type={conditions(ConditionName.isComplexPortrait) ? "modal" : "popover"}
                isBlurBackground={conditions(ConditionName.isComplexPortrait)}
                ref={speedRef}
            >
                <>
                    <p className="pl-text-[15px] pl-font-medium pl-my-4 pl-mr-4">سرعت پخش</p>
                    <ul className="pl-flex pl-flex-col pl-p-0 pl-m-0">
                        {speeds.map((speed: number, index: number) => (
                            <li
                                key={index}
                                className={`pl-flex pl-items-center pl-text-[14px] pl-pr-12 pl-relative pl-cursor-pointer pl-leading-6 hover:pl-bg-main/[0.1] hover:dark:pl-bg-white/[0.25] pl-p-1 ${settings.speed === speed && "pl-tick-icon pl-bg-main-light hover:!pl-bg-main-light  pl-text-dark-5"}`}
                                onClick={() => {
                                    if (!conditions(ConditionName.isStaticFormat)) sendFluentLog(speedChangeLog(speed));
                                    dispatch(setSpeedPopover(false));
                                    dispatch(setUserSettings({...settings, speed}));
                                    createSettings({ ...settings, speed });
                                    videoTag().playbackRate = speed;
                                }}
                            >
                                {speed === 1
                                    ?
                                    <div className="pl-w-full">معمولی</div>
                                    :
                                    <div className="pl-flex pl-items-center pl-gap-2 pl-w-full">
                                        <span>{speed}</span>
                                        <CloseIcon className={`pl-w-3 pl-h-3 pl-mb-1 pl-stroke-gray-800 dark:pl-stroke-dark-5 ${settings.speed === speed && "!pl-stroke-dark-5"}`} />
                                    </div>
                                }
                            </li>
                        ))}
                    </ul>
                </>
            </Popover>
        </div>
    )
};

export default Speed;